import React, { FC } from 'react';
import { Outlet } from 'react-router-dom';

type SuperAdminRedirectProps = { children?: JSX.Element };

// BYPASSED FOR LOCAL DEV - No Identity endpoint available
const SuperAdminRedirect: FC<SuperAdminRedirectProps> = ({ children }) => {
    return children || <Outlet />;
};

export default SuperAdminRedirect;
